module.exports = __webpack_public_path__ + "static/media/theater_troupej_logo6df427a6c5aafcc9b833344845cc25ab.webp";